<div class="subdomainContainer container">
    <div class="card">
		<div class="card-body">
			<h2 class="card-title text-center"><strong>{{ 'register.chooseSubdomain' | translate }}</strong></h2>
			<h4 class="card-subtitle text-center">{{ 'register.toContinue' | translate }}</h4>
			<div class="subdomains-container" [formGroup]="subdomainForm">
				<!-- <mat-radio-group>
					<mat-radio-button *ngFor="let data of array;" [value]="data" (click)="chooseSubdomain(data)">
						<div>{{data.company_name}}</div>
						<hr>
						<div>{{data.subdomain}}</div>
					</mat-radio-button>
				</mat-radio-group> -->
				<div class="subdomain" [ngClass]="{'selected': selectedIndex === i}" *ngFor="let data of subdomains$ | async; let i = index" (click)="chooseSubdomain(data, i)" (dblclick)="submit()">
					<div>{{data.companyName}}</div>
					<hr>
					<div>{{data.subdomain_type == 'consolidate' ? consolidateURL : data.subdomain + '.' + subdomain}}</div>
				</div>
				<button
					mat-button
					type="submit"
					[disabled]="subdomainForm.invalid || loading"
					class="btn btn-block"
					[ngClass]="subdomainForm.invalid || loading ? 'btn-secondary' : 'btn-primary'"
					(click)="submit()"
				>
					{{ 'register.continue' | translate }}
				</button>
			</div>
		</div>
    </div>
</div>
